import { ERROR_REQUEST_CANCLE } from '@web-mail/util';
import { thunkHelperFactory, reduxMessage } from '@web-common/utils/redux_utils';
import { salesPitchRequest as request } from './request';
import { genDefaultPitchDataMap } from '@web-common/state/reducer/salesPitchReducer/config';
import { getIn18Text } from 'api';
const ReducerName = 'SalesPitchReducer';
const Thunks = {};
const ReducersList = [];
const thunkHelper = thunkHelperFactory(ReducerName, Thunks, ReducersList);
thunkHelper({
    name: 'getSalesPitchData',
    request: async (params) => {
        return request.getSalesPitchData(params);
    },
    pending: state => {
        state.isLoading = true;
        state.isFetchFailed = false;
        state.dataMap = genDefaultPitchDataMap();
    },
    fulfilled: (state, action) => {
        const result = action.payload;
        state.isLoading = false;
        state.isFetchFailed = false;
        if (result) {
            state.dataMap = result;
        }
    },
    rejected: (state, action) => {
        var _a;
        const error = ((_a = action === null || action === void 0 ? void 0 : action.error) === null || _a === void 0 ? void 0 : _a.message) || action.payload || action.error;
        if (error !== ERROR_REQUEST_CANCLE) {
            state.isLoading = false;
            state.isFetchFailed = true;
            reduxMessage.error({ content: getIn18Text('JIAZAISHIBAI') });
        }
    },
});
thunkHelper({
    name: 'sortSalesPitch',
    request: async (params, thunkAPI) => {
        const { dispatch } = thunkAPI;
        const reqParams = {
            order: params.newList.map(v => ({ discourseID: v.id, type: v.type })),
            stage: params.stageId,
        };
        try {
            const success = await request.sortSalesPitch(reqParams);
            if (!success) {
                reduxMessage.error({ content: getIn18Text('QINGQIUSHIBAI') });
                dispatch(Thunks.getSalesPitchData({}));
            }
        }
        catch (e) {
            reduxMessage.error({ content: getIn18Text('QINGQIUSHIBAI') });
            dispatch(Thunks.getSalesPitchData({}));
        }
    },
});
thunkHelper({
    name: 'searchSalesPitch',
    request: async (params) => {
        return request.searchSalesPitch(params);
    },
    pending: state => {
        state.isLoading = true;
        state.isFetchFailed = false;
        state.searchDataMap = genDefaultPitchDataMap();
    },
    fulfilled: (state, action) => {
        const result = action.payload;
        state.isLoading = false;
        state.isFetchFailed = false;
        if (result) {
            state.searchDataMap = result;
        }
    },
    rejected: (state, action) => {
        var _a;
        const error = ((_a = action === null || action === void 0 ? void 0 : action.error) === null || _a === void 0 ? void 0 : _a.message) || action.payload || action.error;
        if (error !== ERROR_REQUEST_CANCLE) {
            state.isLoading = false;
            state.isFetchFailed = true;
            reduxMessage.error({ content: getIn18Text('JIAZAISHIBAI') });
        }
    },
});
thunkHelper({
    name: 'fetchData',
    request: async (_params, thunkAPI) => {
        const { dispatch } = thunkAPI;
        const state = thunkAPI.getState().salesPitchReducer;
        if (state.searchInput) {
            dispatch(Thunks.searchSalesPitch({ queryKey: state.searchInput }));
        }
        else {
            dispatch(Thunks.getSalesPitchData({}));
        }
    },
});
thunkHelper({
    name: 'getSalesPitchConfig',
    request: async () => {
        return request.getSalesPitchConfig();
    },
    fulfilled: (state, action) => {
        state.config = action.payload;
    },
    rejected: (state, action) => {
        var _a;
        const error = ((_a = action === null || action === void 0 ? void 0 : action.error) === null || _a === void 0 ? void 0 : _a.message) || action.payload || action.error;
        console.error('getSalesPitchConfig error', error);
        state.config = {
            showEnterprise: true,
        };
    },
});
export const SalesPitchThunks = Thunks;
export const SalesPitchExtraReducersList = ReducersList;
export const SalesPitchExtraReducers = (builder) => {
    SalesPitchExtraReducersList.forEach((fn) => fn(builder));
};
